module.exports = __webpack_public_path__ + "static/animation-ewy-cover-1f0c75dce70c4a951b5b2f0723c29cc6.png";